import * as types from '../const/action.types';
import { get, post } from '../api/_basic';

export function reportsSearchIsLoading(bool) {
    return {
        type: types.REPORT_SEARCH_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsSearchFieldsFetchDataSuccess(items) {
    return {
        type: types.REPORT_SEARCH_FIELDS_FETCH_DATA,
        items,
    };
}

export function reportsSearchValuesFetchDataSuccess(items) {
    return {
        type: types.REPORT_SEARCH_VALUES_FETCH_DATA,
        items,
    };
}

export function loadFields() {
    return async (dispatch) => {
        dispatch(reportsSearchIsLoading(true));
        try {
            const response = await get(process.env.REACT_APP_API_REPORT_SEARCH_FIELD);
            dispatch(reportsSearchIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const items = response;
            dispatch(reportsSearchFieldsFetchDataSuccess(items));
            dispatch(reportsSearchValuesFetchDataSuccess({}));
        } catch (error) {
            dispatch(reportsSearchIsLoading(false));
            throw error;
        }
    };
}

export function clearFields() {
    return (dispatch) => {
        dispatch(reportsSearchValuesFetchDataSuccess({}));
    };
}

function modify(items, equivalences) {
    return items.map((i) => {
        const found = equivalences.find((f) => f.reference === i.valor);
        if (found) {
            i.valor = found.value;
        }
        return i;
    });
}

export function loadValues(
    from,
    to,
    local,
    family,
    proceso,
    field,
    fieldLabel,
    value,
    minimun,
    maximun,
    equivalences,
) {
    return async (dispatch) => {
        dispatch(reportsSearchIsLoading(true));
        try {
            const body = { campo: field };
            if (from) body.fechaInicio = from;
            if (to) body.fechaFin = to;
            if (local) body.local = local;
            if (value) body.valor = value;
            if (proceso) body.proceso = proceso;
            if (minimun || maximun) {
                body.rango = {
                    inferior: minimun,
                    superior: maximun,
                    limiteinferior: true,
                    limitesuperior: true,
                };
            }

            const response = await post(process.env.REACT_APP_API_REPORT_SEARCH_VALUE, body);
            dispatch(reportsSearchIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const items = response;
            const values = equivalences ? modify(items, equivalences) : items;
            dispatch(
                reportsSearchValuesFetchDataSuccess({
                    from: from,
                    to: to,
                    local: local,
                    family: family,
                    process: proceso,
                    field: field,
                    fieldLabel: fieldLabel,
                    value: value,
                    values: values,
                    range: {
                        inferior: minimun,
                        superior: maximun,
                        limiteinferior: true,
                        limitesuperior: true,
                    },
                }),
            );
        } catch (error) {
            dispatch(reportsSearchIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.search.actions.js